import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors, Text } from "../../config/Constants";
import Button from "../Button";
import Search from "../Search";

type HeaderProps = {
  onSearch: (value: any) => void;
  searchQuery: string;
};

const PrivilegeAccountListHeader = () => {
  const navigate = useNavigate();

  return (
    <StyledPrivilegeListClubHeader>
      <StyledPageHeader>{"Manage Account"}</StyledPageHeader>
      <PrivilegeActions>
        {/* <Search placeholder="Search" onChange={onSearch} value={searchQuery} /> */}
        <Button
          variant="filled"
          label={"Add Privilege Account"}
          color={Colors.red}
          onClick={() => {
            navigate(`/admin/add-privilege-account`);
          }}
        ></Button>
      </PrivilegeActions>
    </StyledPrivilegeListClubHeader>
  );
};

const StyledPrivilegeListClubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.25rem;
  @media only screen and (max-width: 1280px) {
    flex-direction: column-reverse;
  }
  @media only screen and (max-width: 768px) {
    padding: 1rem;
    padding-bottom: 0;
  }
`;

export const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  color: ${Colors.black};
  font-weight: 500;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const PrivilegeActions = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  @media only screen and (max-width: 1280px) {
    align-self: flex-end;
    align-items: center;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    gap: 0.5rem;
  }
`;

export default PrivilegeAccountListHeader;
